export const disableSelection = (selector='body')=>{
    setTimeout(()=>{
        document.querySelector(selector) && document.querySelector(selector).setAttribute("onselectstart",'return false;')
    },2000)
}

export const enableSelection = (selector='body')=>{
    setTimeout(()=>{
        document.querySelector(selector) && document.querySelector(selector).setAttribute("onselectstart",'return true;')
    },2000)
    
}